/* eslint-disable */

function headerPin() {

    const headerEl = document.querySelector(".site-header");
    if (!headerEl) {
        return;
    }

    const headerObserver = new IntersectionObserver(
        ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
        { threshold: [1] }
    );

    headerObserver.observe(headerEl);

    const toggleScrolledClass = () => {
        headerEl.classList.toggle('is-scrolled', window.scrollY > 40);
    };

    // Apply state on first paint and keep it in sync while scrolling.
    toggleScrolledClass();
    window.addEventListener('scroll', toggleScrolledClass, { passive: true });


}

function mainNav() {

    /**
     * File navigation.js.
     *
     * Handles toggling the navigation menu for small screens and enables TAB key
     * navigation support for dropdown menus.
     */
    let i, len;

    const container = document.getElementById('site-navigation');
    if (!container) {
        return;
    }

    const mainMenu = document.getElementById('menu-main-menu');

    if ('undefined' === typeof mainMenu) {
        return;
    }


    // toggle click on menu items with class .menu-item-has-children, and add class .open
    const menuItems = document.querySelectorAll('.megaMenuMain__link');
    menuItems.forEach((item) => {

        // add aria-hidden="true" to each .megaMenuWrapper div that is a sibling of item
        const megaMenuWrapper = item.parentNode.querySelector('.megaMenuWrapper');
        if (megaMenuWrapper) {
            megaMenuWrapper.setAttribute('aria-hidden', 'true');
            // find all links in the megaMenuWrapper and add tabindex="-1"
            const megaMenuLinks = megaMenuWrapper.querySelectorAll('a');
            megaMenuLinks.forEach((link) => {
                link.setAttribute('tabindex', '-1');
            });
        }

        item.addEventListener('click', (event) => {
            event.preventDefault();
            const clickedItem = event.currentTarget;
            const thisMegaMenuWrapper = clickedItem.nextElementSibling; // Assuming that megaMenuWrapper is the direct next sibling
        
            // First close all menus and set aria-hidden to true
            menuItems.forEach((otherItem) => {
                const otherMegaMenuWrapper = otherItem.nextElementSibling;
                otherItem.parentNode.classList.remove('open');
                if (otherMegaMenuWrapper) {
                    otherMegaMenuWrapper.setAttribute('aria-hidden', 'true');
                    otherMegaMenuWrapper.querySelectorAll('a').forEach((link) => {
                        link.setAttribute('tabindex', '-1');
                    });
                }
            });
        
            // Then toggle the class on the clicked item and set aria-hidden appropriately
            clickedItem.parentNode.classList.toggle('open');
        
            if (thisMegaMenuWrapper) {
                if (clickedItem.parentNode.classList.contains('open')) {
                    thisMegaMenuWrapper.setAttribute('aria-hidden', 'false');
                    thisMegaMenuWrapper.querySelectorAll('a').forEach((link) => {
                        link.setAttribute('tabindex', '0');
                    });
                } else {
                    thisMegaMenuWrapper.setAttribute('aria-hidden', 'true');
                    thisMegaMenuWrapper.querySelectorAll('a').forEach((link) => {
                        link.setAttribute('tabindex', '-1');
                    });
                }
            }
        });
    });

    // click anywhere outside of menu to close menu
    document.addEventListener('click', (event) => {
        const target = event.target;
        const isClickInside = container.contains(target);
        if (!isClickInside) {
            menuItems.forEach((item) => {
                item.parentNode.classList.remove('open');

                // add aria-hidden="true" to each .megaMenuWrapper div that is a sibling of item
                const megaMenuWrapper = item.parentNode.querySelector('.megaMenuWrapper');
                if (megaMenuWrapper) {
                    megaMenuWrapper.setAttribute('aria-hidden', 'true');
                    megaMenuWrapper.querySelectorAll('a').forEach((link) => {
                        link.setAttribute('tabindex', '-1');
                    });
                }
            });
        }
    });

    // press escape key to close menu
    document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
            menuItems.forEach((item) => {
                item.parentNode.classList.remove('open');

                // add aria-hidden="true" to each .megaMenuWrapper div that is a sibling of item
                const megaMenuWrapper = item.parentNode.querySelector('.megaMenuWrapper');
                if (megaMenuWrapper) {
                    megaMenuWrapper.setAttribute('aria-hidden', 'true');
                    megaMenuWrapper.querySelectorAll('a').forEach((link) => {
                        link.setAttribute('tabindex', '-1');
                    });
                }
            });
        }
    });

};

const init = () => {
    headerPin();
    mainNav();
};

export default init;
